import { useEffect } from 'react';
import { useAuth } from '../providers/AuthProvider';
import { useNavigate } from 'react-router';
import { Spinner } from '../components/progress';
import { useFlagEvaluationQuery } from 'analytics/useFlagEvaluation';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { isLoading: flagsLoading } = useFlagEvaluationQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      void navigate('/', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);
  if (loading || flagsLoading) {
    return <Spinner />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
